<template>
  <div>
    <g-master name="trabajos"
              :endpoint="lvlComMaster.endpoint"
              :tableSetup="lvlComMaster.tableSetup"
              :modalFieldsSetup="lvlComMaster.modalFieldsSetup"
              :parentData="parentData"
              ref="lvlComMaster"
              :beforeSend="lvlComMaster.beforeSend"
    >
      <template slot="masterModal" slot-scope="{record}">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Descripción')">
              <a-textarea autoSize
                          v-decorator="['description', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Peso (%)')">
              <a-input-number style="width: 100%"
                              v-decorator="['attribute_1', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <g-dropdown v-bind="fiOptions"
                        endpoint="hierarchy_lookup"
                        :label="$t('Tipo objetivo')"
                        :formItemConfig="fiOptions"
                        :decorator="['id_h_objective_type', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                        :params="tipoObjetivo"
                        ref="coc"
            >
            </g-dropdown>
          </a-col>
        </a-row>
      </template>
    </g-master>
    <a-tabs default-active-key="1">
      <a-tab-pane tab="NIVEL DEL CARGO" key="1">
        <objectives-position v-if="idLevel" :id_level="idLevel"></objectives-position>
        <span v-else>Seleccione un objetivo para ver más.</span>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        tipoObjetivo: {
          h_lookup_type: 'TIPO_OBJETIVO_EVALUACION_'
        },
        colOptions: {xs: 24, sm: 24},
        visible: false,
        nombre: '',
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        lvlComMaster: {
          beforeSend: (data) => {
            data.id_level = this.id_level
            return data
          },
          endpoint: 'objectives',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Descripción', dataIndex: 'description', sorter: true},
              {title: 'Peso', dataIndex: 'attribute_1', sorter: true},
              {title: 'Tipo de objetivo', dataIndex: 'tipo_objetivo', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'description'},
            {name: 'attribute_1'},
            {name: 'id_h_objective_type'}
          ]
        }
      }
    },
    props: ['id_evaluation'],
    computed: {
      parentData () {
        return {
          id_management_skill: this.id_evaluation
        }
      },
      idLevel () {
        return this.lvlComMaster.tableSetup.selectedRows.length > 0 ? this.lvlComMaster.tableSetup.selectedRows[0].id : null
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/Objectives.vue